import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { storeCustomerGetInfo } from "../../services/CustomerInfo/CustomerInfo";
import { getCustomerSingleOrderInfo, getCustomerSingleOrderReOpen } from "../../services/OrdersAPI/Orders";
import { getReadyToDeliveryQrCode } from "../../services/QrCode/getReadyToDeliveryQrCode";
import { getOrderPaymentDetails } from "../../services/OrderPayment/orderPayment";
import { postQrCodeByStatus } from "../../services/QrCode/postQrCodeByStatus";
import { getStoreDefaultPrice } from "../../services/StoreDefaultPrice/getStoreDefaultPrice";
import OrderInfoCard from "./OrderInfoCard";
import PaymentInfoCard from "./PaymentInfoCard";
import PackageInfoCard from "./PackageInfoCard";
import GarmentInfoCard from "./GarmentInfoCard";
import { Button } from "primereact/button";
import OrderCancelModal from "./OrderCancelModal";
import OrderInfoEdit from "./OrderInfoEdit";
import OrderUnprocessedQrCode from "./OrderUnprocessedQrCode";
import SuccessModal from "../SuccessModal";
import StoreMenu from "../StoreMenu";
import OrderNotification from "./OrderNotification";
import AdminMenu from "../AdminMenu";
import CollectPayment from "./CollectPayment";
import { getBrandStoreById } from "../../services/StoreUsers/PostStoreUsers";
import CollectPaymentAdmin from "./CollectPaymentAdmin";
import OrderInfoEditAdmin from "./OrderInfoEditAdmin";
import SupportAdminMenu from "../SupportAdminMenu";
import { OrderEditWithType } from "../../services/StoreOrder/StoreOrder";
import { Pencil, Lock } from "lucide-react";

const { innerWidth: width, innerHeight: height } = window;


const styles = {
  track: (editing) => ({
    position: "relative",
    width: 112,
    height: 35,
    borderRadius: 999,
    border: `1.5px solid ${editing ? "#8FD4A6" : "#e3d7d7"}`,
    backgroundColor: editing ? "#E4F5E9" : "#f5eeee",
    overflow: "hidden",
    cursor: "pointer",
    transition: "background-color 300ms, border-color 300ms",
    padding: 0,
  }),
  label: (editing) => ({
    position: "absolute",
    inset: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 13.5,
    fontWeight: 600,
    color: editing ? "#1F7A38" : "#745b5b",
    paddingLeft: editing ? 6 : 34,
    paddingRight: editing ? 34 : 6,
    transition: "padding 300ms, color 300ms",
    boxSizing: "border-box",
  }),
  thumb: (editing) => ({
    position: "absolute",
    top: 3,
    left: editing ? "calc(100% - 36px)" : 4,
    height: 26,
    width: 26,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: editing ? "#2FA84F" : "#ad9494",
    boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
    transition: "left 300ms cubic-bezier(.4,1.4,.6,1), background-color 300ms",
  }),
  icon: (visible, editing) => ({
    position: "absolute",
    opacity: visible ? 1 : 0,
    transform: visible
      ? "scale(1) rotate(0deg)"
      : `scale(0.4) rotate(${editing ? -45 : 45}deg)`,
    transition: "opacity 200ms, transform 200ms",
  }),
};

const CardDataOnDoneOrder = [
  {
    id: 1,
    name: "Order Invoice",
    fillColor: "#FFF9DE",
    borderColor: "#F5C43A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png",
  },
  {
    id: 2,
    name: "Garment Tag",
    fillColor: "#E4FFE6",
    borderColor: "#55BD5A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_QR_Code.png",
  },
  {
    id: 3,
    name: "Cancel Order",
    fillColor: "#FFEEEE",
    borderColor: "#FF6767",
    img: "Laundy_App_Icons_Gifs/Other_Icons/Cancel_Order.png",
  },
];
 

const CardDataAfterCancelOrder = [
  {
    id: 1,
    name: "Canceled Order",
    // fillColor: '#E7F4FF', // You can set the desired colors
    borderColor: "red", // You can set the desired colors
    img: "Laundy_App_Icons_Gifs/Customer_Info_GIFs/Cancel_Order.gif", // Provide the correct image path
  },
];

const CardDataViewInvoice = [
  {
    id: 1,
    name: "Order Invoice",
    fillColor: "#FFF9DE",
    borderColor: "#F5C43A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/View_Invoice.png",
  },
];

function EditModePill({ editing, setEditing, loading = false }) {
  return (
    <button
      onClick={() => !loading && setEditing(!editing)}
      aria-pressed={editing}
      disabled={loading}
      style={{
        ...styles.track(editing),
        opacity: loading ? 0.65 : 1,
        cursor: loading ? "default" : "pointer",
        pointerEvents: loading ? "none" : "auto",
      }}
    >
      <span style={styles.label(editing)}>
        {loading ? "Updating..." : editing ? "Edit on" : "Edit off"}
      </span>

      <span style={styles.thumb(editing)}>
        {loading ? (
          <span
            style={{
              width: 12,
              height: 12,
              borderRadius: "50%",
              border: "2px solid rgba(255,255,255,0.4)",
              borderTopColor: "white",
              animation: "spin 700ms linear infinite",
            }}
          />
        ) : (
          <>
            <Pencil size={14} color="white" strokeWidth={2.4} style={styles.icon(editing, editing)} />
            <Lock size={14} color="white" strokeWidth={2.4} style={styles.icon(!editing, editing)} />
          </>
        )}
      </span>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </button>
  );
}
 
const AdminOrdersGarmentInfo = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeIdValue, bookingOrderId, storeCustomerId, navigateThrough } = location.state || {}; // Fallback to prevent undefined errors

  let storeId = storeIdValue;

  const {
    brandProfileData,
    userProfileData,
    userProfileRole,
    garmentCategoryServiceIconsResData,
  } = getUserData();

  const [storeData, setStoreData] = useState({})

  const userRole = userProfileRole;

  let brandId = brandProfileData.id;
  const storeUserId = userProfileData.id;
  const profileCreatedDate = userProfileData.createdDate;
  const processTime = storeData.processTime;
  const storeGstNumber = storeData.gstNo;
  let orderEditByStore = storeData.orderEditByStore;
  let orderEditByRider = storeData.orderEditByRider;
  let deliveryDiscount = storeData.enableDeliveryDiscount;
  let enableUserAccountDeliveryDiscount =
    storeData.enableUserAccountDeliveryDiscount;
  const enabledChargeDiscountByService =
    storeData.enabledChargeDiscountByService;
  const enabledCustomDiscountCharge = storeData.enabledCustomDiscountCharge;
    let enabledSubscriptionDiscountOnDelivery =
      storeData.enabledSubscriptionDiscountOnDelivery;
  let enabledCreatePaymentLink = storeData.enabledCreatePaymentLink;
  let enabledGarmentInspection = storeData.enabledGarmentInspection;
  let offerPriceEnabled = storeData.offerPriceEnabled;
  const garmentMaxProcessCount = brandProfileData.garmentMaxProcessCount;
  const enabledReOpenOrder = brandProfileData.enabledReOpenOrder;
  let enabledUPIAccount = storeData.enabledUPIAccount;

  const offerDiscountByStore = storeData.offerDiscountByStore;
  const offerDiscountByRider = storeData.offerDiscountByRider;
  const enabledAmountRoundOff = storeData.enabledAmountRoundOff ? 0 : 2;  
  let enabledOrderBulkEdit = storeData.enabledOrderBulkEdit;

  const [processOrderActive, setProcessOrderActive] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [cancelOrderModal, setCancelOrderModal] = useState(false);
  const [modalText, setModalText] = useState("");
  const [modalStatusText, setModalStatusText] = useState("");
  const [customerOrdersData, setCustomerOrdersData] = useState({});
  const [storeCustomerData, setStoreCustomerData] = useState({});
 
  const [orderNotificationVisible, setOrderNotificationVisible] =
    useState(false);
  const [orderNotificationMessageType, setOrderNotificationMessageType] =
    useState("");

  const [collectPaymentModalVisible, setCollectPaymentModalVisible] =
        useState(false);

  const [orderEditMode, setOrderEditMode] = useState("")
 
  const [orderInfoEditVisible, setOrderInfoEditVisible] = useState(false);
  const [orderUnprocessedQrCode, setOrderUnprocessedQrCode] = useState(false);
  const [storeDefaultPrice, setStoreDefaultPrice] = useState([]);
  const [orderPaymentDetailsData, setOrderPaymentDetailsData] = useState([]);
  const [processGarment, setProcessGarment] = useState(false);
  const [visible, setVisible] = useState(false);
  const handleBackButton = () => {
    if(navigateThrough === 'GoBack') {
      navigate(-1)
  } else {
    navigate('/');
  }  
  };

   const fetchStoreUser = () => {
     getBrandStoreById(storeId)
       .then((response) => {
         if (!response.data.error) {
           const Res = response.data;
           setStoreData(Res);
         }
       })
       .catch((err) => {
         console.error("Error:", err);
       });
   };

  const fetchStoreCustomerGetInfo = () => {
    storeCustomerGetInfo(storeCustomerId, storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreCustomerData(Res);
        }
      })
      .catch((err) => {
        console.error("storeCustomerGetInfo Error:", err);
      });
  };

  const fetchCustomerSingleOrder = () => {
    // getCustomerSingleOrder(storeCustomerId, storeId, bookingOrderId)
    getCustomerSingleOrderInfo(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setCustomerOrdersData(Res);
          setOrderEditMode(Res?.orderUnderEdit)
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });

    getReadyToDeliveryQrCode(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          if (
            response.data.processedList.length > 0 ||
            response.data.readyToDeliveryList.length > 0
          ) {
            setProcessGarment(true);
          } else {
            setProcessGarment(false);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    getOrderPaymentDetails(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setOrderPaymentDetailsData(Res);
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });
  };

  const fetchDefaultPrice = () => {
    getStoreDefaultPrice(storeId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreDefaultPrice(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

   const [editModeLoading, setEditModeLoading] = useState(false);
  
    const handleOrderEditMode = (value) => {
      if (editModeLoading) return; // guard against re-entry while a request is in flight
  
      const orderEditType = value ? 'on' : 'off';
      setEditModeLoading(true);
  
      OrderEditWithType(storeId, storeCustomerId, customerOrdersData?.id, orderEditType)
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res.status) {
              setOrderEditMode(value);
              fetchCustomerSingleOrder();
              fetchStoreCustomerGetInfo();
              fetchGetDeliveryQrCode({ status: ["UNPROCESSED"] });
            }
          }
        })
        .catch((err) => console.error("Error:", err))
        .finally(() => setEditModeLoading(false));
    };
  

  const ReOpenCustomerOrder = () => {
    // getCustomerSingleOrder(storeCustomerId, storeId, bookingOrderId)
    getCustomerSingleOrderReOpen(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          if(Res.status === true) {
            setModalVisible(true);
            setModalStatusText("success");
            setModalText(Res.message);
            fetchStoreUser();
            fetchCustomerSingleOrder();
            fetchStoreCustomerGetInfo();
            const data = {
              // status: ['OUT_FOR_DELIVERY'], // no need to do this
              status: ["UNPROCESSED"],
            };
            fetchGetDeliveryQrCode(data);
            fetchDefaultPrice();
          } else {
            setModalVisible(true);
            setModalStatusText("failed");
            setModalText(Res.message);
          }
        }
      })
      .catch((err) => {
        console.error("getCustomerSingleOrder Error:", err);
      });
    }

  const [readyToDeliveryUnprocessedData, setReadyToDeliveryUnprocessedData] =
    useState([]);

  const fetchGetDeliveryQrCode = (data) => {
    postQrCodeByStatus(storeCustomerId, storeId, bookingOrderId, data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setReadyToDeliveryUnprocessedData(Res);
          // setReadyToDeliveryData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const [collectPaymentResponse, setCollectPaymentResponse] = useState(null);

  const receiveResponse = ({ message, status, modalFun }) => {
    setModalStatusText(status ? "success" : "failed");
    setModalText(message);
    setCollectPaymentResponse(modalFun);
    fetchCustomerSingleOrder();
    const data = {
      // status: ['OUT_FOR_DELIVERY'], // no need to do this
      status: ["UNPROCESSED"],
    };
    fetchGetDeliveryQrCode(data);
    // setCollectPaymentModalVisible(modalFun);
  };

  const receiveResponseCollectPaymentQrCode = ({ modalFun }) => {
    fetchCustomerSingleOrder();
    const data = {
      // status: ['OUT_FOR_DELIVERY'], // no need to do this
      status: ["UNPROCESSED"],
    };
    fetchGetDeliveryQrCode(data);
  };


  useEffect(() => {
    if (collectPaymentResponse === false) {
      setModalVisible(true);
      setCollectPaymentResponse(null);
    }
  }, [collectPaymentResponse]);

  useEffect(() => {
    fetchStoreUser();
    fetchCustomerSingleOrder();
    fetchStoreCustomerGetInfo();
    const data = {
      // status: ['OUT_FOR_DELIVERY'], // no need to do this
      status: ["UNPROCESSED"],
    };
    fetchGetDeliveryQrCode(data);
    fetchDefaultPrice();
  }, []);

  const CustomerInformation = {
    firstName: storeCustomerData?.brandCustomer?.firstName
      ? storeCustomerData?.brandCustomer?.firstName
      : "",
    lastName: storeCustomerData?.brandCustomer?.lastName
      ? storeCustomerData?.brandCustomer?.lastName
      : "",
    mobile: storeCustomerData?.brandCustomer?.mobile
      ? storeCustomerData?.brandCustomer?.mobile
      : "N/A",
  };

  const selectedUnprocessedQrCodeItems = readyToDeliveryUnprocessedData.map(
    (item) => ({
      id: item.id,
      qrcode: item.qrcode,
      checked: true,
    })
  );

  const orderInfoDetailsBalanceAmount = {
    balanceAmount: customerOrdersData?.balanceAmount
      ? customerOrdersData?.balanceAmount
      : 0,
  };

  const orderItemData = customerOrdersData?.orderItem;
  const orderPackageData = customerOrdersData?.orderPackage;
  const b2BChallanOrder = customerOrdersData?.b2BChallanOrder;

  const receiveDataFromCancelModal = ({ dataRes }) => {
    // setSchedularDate(newSchedular);
    if (dataRes) fetchCustomerSingleOrder();
  };
 
  const onSelectCategoryOnDoneOrder = (item) => {
    if (item.id === 1) {
      navigate("/ViewInvoice", {
        state: {
          storeIdValue:storeIdValue,
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else if (item.id === 2) {
      navigate("/ViewQrCode", {
        state: {
          storeIdValue:storeIdValue,
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else if (item.id === 3) {
      setCancelOrderModal(true);
    } else {
      navigate("/");
    }
  };

 

  const receiveDataFromGarmentInfoCard = ({ info }) => {
    if (info) {
      fetchCustomerSingleOrder();
      fetchStoreCustomerGetInfo();
      const data = {
        // status: ['OUT_FOR_DELIVERY'], // no need to do this
        status: ["UNPROCESSED"],
      };
      fetchGetDeliveryQrCode(data);
      fetchDefaultPrice();
    }
  };

  const handleNotificationModal = (messageType) => {
    setOrderNotificationVisible(true);
    setOrderNotificationMessageType(messageType);
  };

  const renderCardOnDoneOrder = () => {
    return CardDataOnDoneOrder?.map((item, index) => {
      const showLock = ["DONE", "DELIVERED"].includes(customerOrdersData.status) && item.id === 3;
      return (
        <div
          className="cursor-pointer"
          onClick={() => {
            {
              !showLock && onSelectCategoryOnDoneOrder(item);
            }
          }}
        >
          <div className="flex justify-content-center align-items-center">
            <div
              className="flex justify-content-center align-items-center border-1"
              style={{
                height: height < 600 ? 51 : 61,
                width: height < 600 ? 51 : 61,
                backgroundColor: item.fillColor,
                borderRadius: 50,
                borderColor: item.borderColor,
              }}
            >
              {showLock ? (
                <img
                  src={"Icons/lock.png"}
                  style={{
                    width: height < 600 ? 45 : 50,
                    height: height < 600 ? 45 : 50,
                    backgroundColor: "transparent",
                  }}
                />
              ) : (
                <img
                  src={item.img}
                  style={{
                    width: height < 600 ? 25 : 30,
                    height: height < 600 ? 25 : 30,
                    alignSelf: "center",
                  }}
                />
              )}
            </div>
          </div>

          <div className="py-2">
            <p
              className="text-xl font-normal capitalize"
              style={
                index === 0 && processOrderActive === item.id
                  ? { color: "#008EFF" }
                  : { color: "#75879B" }
              }
            >
              {item.name}
            </p>
          </div>
        </div>
      );
    });
  };

  

  const renderCardViewInvoice = () => {
    return CardDataViewInvoice?.map((item, index) => (
      <div
        className="cursor-pointer"
        onClick={() => {
          {
              onSelectCategoryOnDoneOrder(item);
          }
        }}
      >
        <div className="flex justify-content-center align-items-center">
          <div
            className="flex justify-content-center align-items-center border-1"
            style={{
              height: height < 600 ? 51 : 61,
              width: height < 600 ? 51 : 61,
              backgroundColor: item.fillColor,
              borderRadius: 50,
              borderColor: item.borderColor,
            }}
          >
             
              <img
                src={item.img}
                style={{
                  width: height < 600 ? 25 : 30,
                  height: height < 600 ? 25 : 30,
                  alignSelf: "center",
                }}
              />
             
          </div>
        </div>

        <div className="py-2">
          <p
            className="text-xl font-normal capitalize"
            style={
              index === 0 && processOrderActive === item.id
                ? { color: "#008EFF" }
                : { color: "#75879B" }
            }
          >
            {item.name}
          </p>
        </div>
      </div>
    ));
  };
  

  const renderCardAfterCancelOrder = () => {
    return CardDataAfterCancelOrder?.map((item, index) => (
      <div>
        <div className="flex justify-content-center align-items-center">
          <div
            className="flex justify-content-center align-items-center border-1"
            style={{
              height: height < 600 ? 51 : 61,
              width: height < 600 ? 51 : 61,
              backgroundColor: item.fillColor,
              borderRadius: 50,
              borderColor: item.borderColor,
            }}
          >
            <img
              src={item.img}
              style={{
                width: height < 600 ? 25 : 30,
                height: height < 600 ? 25 :  30,
                alignSelf: "center",
              }}
            />
          </div>
        </div>

        <div className="py-2">
          <p
            className="text-xl font-normal capitalize"
            style={
              index === 0 && processOrderActive === item.id
                ? { color: "#008EFF" }
                : { color: "#75879B" }
            }
          >
            {item.name}
          </p>
        </div>
      </div>
    ));
  };
 

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#fff",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left cursor-pointer"
                  onClick={() => handleBackButton()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#000" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl font-bold capitalize">Order Info</p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#000" }}
            ></i>
          </div>
        </div>
      </div>

      <div
        className="border-none surface-0 flex-1  mx-4 py-1 mb-3"
        style={{
          borderRadius: 5,
          backgroundImage:
            "radial-gradient(circle at left top, #1752AA, #2B70D7)",
        }}
      >
        <div className="px-4">
          <div
            className="flex cursor-pointer"
            onClick={() =>
              userRole !== "BY_SUPPORT_ADMIN" &&
              navigate("/CustomerInfo", {
                state: {
                  storeCustomerId: storeCustomerId,
                  storeId: storeId,
                },
              })
            }
          >
            <div className="flex-1 flex justify-content-start align-items-center">
              <p className="text-white text-lg font-normal capitalize">
                Customer Name :
              </p>
              <p className="text-white text-xl font-semibold capitalize ml-2">
                {CustomerInformation?.firstName} {CustomerInformation?.lastName}
              </p>
            </div>
            <div className="flex-1 flex justify-content-start align-items-center">
              <p className="text-white text-lg font-normal capitalize ">
                Mobile No. :
              </p>
              <p className="text-white text-xl font-semibold capitalize ml-2">
                {CustomerInformation?.mobile}
              </p>
            </div>
          </div>
        </div>
      </div>
      {userRole === "BY_SUPPORT_ADMIN" ?
      <div className="flex flex-1 justify-content-around align-item-center">
         
        {renderCardViewInvoice()}
      </div>
      :
      <div className="flex flex-1 justify-content-around align-item-center">
        {!["CANCEL"].includes(customerOrdersData.status) && (
          <React.Fragment>
            {renderCardOnDoneOrder()}

            {!enabledReOpenOrder && ["DONE"].includes(customerOrdersData.status) &&
              <div
                className="cursor-pointer"
                onClick={() => {
                  ReOpenCustomerOrder();
                }}
              >
                <div className="flex justify-content-center align-items-center">
                  <div
                    className="flex justify-content-center align-items-center border-1"
                    style={{
                      height: height < 600 ? 51 : 61,
                      width: height < 600 ? 51 : 61,
                      backgroundColor: "#FFF9DE",
                      borderRadius: 50,
                      borderColor: "#F5C43A",
                    }}
                  >

                    <img
                      src={"Laundy_App_Icons_Gifs/Other_Icons/open.png"}
                      style={{
                        width: height < 600 ? 30 : 40,
                        height: height < 600 ? 30 : 40,
                        backgroundColor: "transparent",
                      }}
                    />
                  </div>
                </div>

                <div className="py-2">
                  <p
                    className="text-xl font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Re-Open Order
                  </p>
                </div>
              </div>
            }
            {customerOrdersData.balanceAmount > 0 && (
              <div
                className="cursor-pointer"
                onClick={() => {
                  customerOrdersData.appliedSubscriptionDiscount === false &&
                    customerOrdersData.subscriptionDiscount === 0 &&
                    setCollectPaymentModalVisible(true);
                }}
              >
                <div className="flex justify-content-center align-items-center">
                  <div
                    className="flex justify-content-center align-items-center border-1"
                    style={{
                      height: height < 600 ? 51 : 61,
                      width: height < 600 ? 51 : 61,
                      backgroundColor: "#FFF9DE",
                      borderRadius: 50,
                      borderColor: "#F5C43A",
                    }}
                  >
                    {customerOrdersData.appliedSubscriptionDiscount &&
                      customerOrdersData.subscriptionDiscount > 0 ? (
                      <img
                        src={"Icons/lock.png"}
                        style={{
                          width: height < 600 ? 45 : 50,
                          height: height < 600 ? 45 : 50,
                          backgroundColor: "transparent",
                        }}
                      />
                    ) : (
                      <img
                        src="Laundy_App_Icons_Gifs/Packages_GIFs/package4.gif"
                        style={{
                          width: height < 600 ? 25 : 30,
                          height: height < 600 ? 25 : 30,
                          alignSelf: "center",
                        }}
                      />
                    )}
                  </div>
                </div>

                <div className="py-2">
                  <p
                    className="text-xl font-normal capitalize"
                    style={{ color: "#75879B" }}
                  >
                    Collect Payment
                  </p>
                </div>
              </div>
            )}
          </React.Fragment>
        )}
        {customerOrdersData.status === "CANCEL" && renderCardAfterCancelOrder()}
      </div>
      }
      <div className="flex flex-1">
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5", position: "relative" }}
          >
            <div className="flex justify-content-between mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">Order Info</p>
              </div>
            </div>
            {enabledOrderBulkEdit && userRole === "BY_ADMIN" && <React.Fragment>
                            <div
                              style={{
                                position: "absolute",
                                right: 60,
                                top: 2,
                              }}
                            >
                              <div style={{  display: "flex", alignItems: "center", justifyContent: "center", }}>
                                <EditModePill editing={orderEditMode} setEditing={handleOrderEditMode} loading={editModeLoading} />
                            </div>
                            </div>
                          </React.Fragment>}
            <div>
              {![
                // "DONE",
                 "CANCEL"].includes(customerOrdersData.status) 
                && userRole !== "BY_SUPPORT_ADMIN" && (
                <div
                  style={{
                    position: "absolute",
                    right: 30,
                    top: 9,
                  }}
                >
                  <div>
                    <div onClick={() => setOrderInfoEditVisible(true)}>
                      <i
                        className="pi pi-pencil"
                        style={{
                          fontSize: "20px",
                          cursor: "pointer",
                          color: "#2B70D7",
                        }}
                      ></i>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
          <OrderInfoCard
            customerOrdersData={customerOrdersData}
            storeCustomerId={storeCustomerId}
            bookingOrderId={bookingOrderId}
            userRole={userRole}
            storeId={storeId}
            enabledChargeDiscountByService={enabledChargeDiscountByService}
            enabledCustomDiscountCharge={enabledCustomDiscountCharge}
            storeUserId={storeUserId}
            brandId={brandId}
            enabledCreatePaymentLink={enabledCreatePaymentLink}
            updateOrderGarmentInfoPage={receiveDataFromGarmentInfoCard}
            b2BChallanOrder={b2BChallanOrder}
            enabledAmountRoundOff={enabledAmountRoundOff}
          />

          {/** Payment Info */}
          {orderPaymentDetailsData?.length > 0 && (
            <PaymentInfoCard
              orderPaymentDetailsData={orderPaymentDetailsData}
              storeCustomerId={storeCustomerId}
              storeId={storeId}
              bookingOrderId={bookingOrderId}
              sendDataToOrderGarmentInfo={receiveDataFromGarmentInfoCard}
              balanceAmount={orderInfoDetailsBalanceAmount.balanceAmount}
              customerOrdersData={customerOrdersData}
              enableUserAccountDeliveryDiscount={
                enableUserAccountDeliveryDiscount
              }
              storeUserId={storeUserId}
              userRole={userRole}
              brandId={brandId}
              enabledAmountRoundOff={enabledAmountRoundOff}

            />
          )}
          {/** Package Info */}
          {orderPackageData?.length > 0 && (
            <PackageInfoCard
              orderPackageData={orderPackageData}
              storeCustomerId={storeCustomerId}
              storeId={storeId}
              bookingOrderId={bookingOrderId}
              sendDataToOrderGarmentInfo={receiveDataFromGarmentInfoCard}
              userRole={userRole}
              orderEditByStore={orderEditByStore}
              orderEditByRider={orderEditByRider}
              customerOrdersData={customerOrdersData}
              offerPriceEnabled={offerPriceEnabled}
            />
          )}
        </div>
        <div className="flex-1">
          <div
            className="flex-1  surface-0"
            style={{ "--surface-0": "#EAEFF5" }}
          >
            <div className="flex justify-content-between mx-4">
              <div className="py-1">
                <p className=" text-2xl  font-bold ">Garment Info</p>
              </div>
              <div className="flex justify-content-center align-items-center">
                <div className="mr-4 cursor-pointer">
                  {enabledGarmentInspection && userRole !== "BY_SUPPORT_ADMIN" && (
                    <div
                      className="relative"
                      onClick={() =>
                        navigate("/GarmentQrCodeList", {
                          state: {
                            mobileNumber: CustomerInformation.mobile,
                            customerFirstName: CustomerInformation.firstName,
                            customerLastName: CustomerInformation.lastName,
                            storeCustomerId: storeCustomerId,
                            bookingOrderId: bookingOrderId,
                            invoiceNo: customerOrdersData.invoiceNo,
                            orderNo: customerOrdersData.orderNo,
                            storeId: storeId,
                          },
                        })
                      }
                    >
                      <div
                        style={{
                          position: "absolute",
                          right: 2,
                          top: -12,
                        }}
                      >
                        <i
                          className="pi pi-image"
                          style={{
                            fontSize: "20px",
                            cursor: "pointer",
                            color: "#2B70D7",
                          }}
                        ></i>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <GarmentInfoCard
            orderItemData={orderItemData}
            storeCustomerId={storeCustomerId}
            storeId={storeId}
            bookingOrderId={bookingOrderId}
            brandId={brandId}
            priceId={storeDefaultPrice.id}
            sendDataToOrderGarmentInfo={receiveDataFromGarmentInfoCard}
            offerDiscountByStore={offerDiscountByStore}
            offerDiscountByRider={offerDiscountByRider}
            userRole={userRole}
            offerPriceEnabled={offerPriceEnabled}
            garmentMaxProcessCount={garmentMaxProcessCount}
            garmentServiceIcons={garmentCategoryServiceIconsResData?.iconMap}
            enableDeleteItem={true}
            b2BChallanOrder={b2BChallanOrder}
            enabledAmountRoundOff={enabledAmountRoundOff}
          />
        </div>
      </div>
      <div>
        <OrderInfoEditAdmin
          setOrderInfoEditVisible={setOrderInfoEditVisible}
          orderInfoEditVisible={orderInfoEditVisible}
          customerOrdersData={customerOrdersData}
          storeId={storeId}
          storeUserId={storeUserId}
          storeCustomerId={storeCustomerId}
          processTime={processTime}
          sendResponse={receiveResponse}
          storeGstNumber={storeGstNumber}
          storeCustomerData={storeCustomerData}
          profileCreatedDate={profileCreatedDate}
        />
        <OrderUnprocessedQrCode
          setOrderUnprocessedQrCode={setOrderUnprocessedQrCode}
          orderUnprocessedQrCode={orderUnprocessedQrCode}
          selectedUnprocessedQrCodeItems={selectedUnprocessedQrCodeItems}
          storeId={storeId}
          storeUserId={storeUserId}
          storeCustomerId={storeCustomerId}
          processTime={processTime}
          bookingOrderId={bookingOrderId}
          sendResponse={receiveResponse}
        />
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={modalStatusText}
          text={modalText}
        />
        <OrderCancelModal
          setCancelOrderModal={setCancelOrderModal}
          cancelOrderModal={cancelOrderModal}
          sendDataToOrderInfoPage={receiveDataFromCancelModal}
          storeId={storeId}
          storeCustomerId={storeCustomerId}
          bookingOrderId={bookingOrderId}
        />
        {collectPaymentModalVisible && (
          <CollectPaymentAdmin
            setCollectPaymentModalVisible={setCollectPaymentModalVisible}
            collectPaymentModalVisible={collectPaymentModalVisible}
            balanceAmount={orderInfoDetailsBalanceAmount.balanceAmount}
            storeCustomerId={storeCustomerId}
            storeId={storeId}
            storeUserId={storeUserId}
            bookingOrderId={bookingOrderId}
            sendResponse={receiveResponse}
            sendResponseQrPayment={receiveResponseCollectPaymentQrCode}
            onClose={() => {
              fetchCustomerSingleOrder();
              fetchStoreCustomerGetInfo();
            }}
            deliveryDiscount={deliveryDiscount}
            enableUserAccountDeliveryDiscount={
              enableUserAccountDeliveryDiscount
            }
            enabledCreatePaymentLink={enabledCreatePaymentLink}
            brandId={brandId}
            enabledSubscriptionDiscountOnDelivery={
              enabledSubscriptionDiscountOnDelivery
            }
            subscriptionDiscount={customerOrdersData.subscriptionDiscount}
            appliedSubscriptionDiscount={
              customerOrdersData.appliedSubscriptionDiscount
            }
            paidAmount={customerOrdersData.paidAmount}
            userProfileData={userProfileData}
            enabledUPIAccount={enabledUPIAccount}
            enabledAmountRoundOff={enabledAmountRoundOff}
          />
        )}
      </div>
      <div className="relative mt-8">
        <div
          className="flex flex-1 flex-row gap-5 w-full py-2 fixed z-2 bottom-0"
          style={{ backgroundColor: "white" }}
        >
          <div className="flex-1 flex-row mx-4 mb-1 gap-2">
            <Button
              // onClick={() =>  handleNotificationModal('SMSMessage')}
              className="p-2 w-full text-2xl border-1 flex justify-content-center"
              style={{
                color: "#fff",
                backgroundColor: "#2B70D7",
                borderRadius: 5,
              }}
            >
              <i
                className="pi pi-book "
                style={{ fontSize: "30px", cursor: "pointer", color: "#fff" }}
              ></i>
            </Button>
            <Button
              onClick={() => handleNotificationModal("WhatsAppMessage")}
              className="p-2 w-full text-2xl border-1 flex justify-content-center"
              style={{
                color: "#fff",
                backgroundColor: "#2B70D7",
                borderRadius: 5,
              }}
            >
              <i
                className="pi pi-whatsapp "
                style={{ fontSize: "30px", cursor: "pointer", color: "#fff" }}
              ></i>
            </Button>
          </div>
        </div>
      </div>
      <OrderNotification
        setOrderNotificationVisible={setOrderNotificationVisible}
        orderNotificationVisible={orderNotificationVisible}
        mobileNumber={CustomerInformation.mobile}
        orderNotificationMessageType={orderNotificationMessageType}
        storeCustomerId={storeCustomerId}
        storeId={storeId}
        bookingOrderId={bookingOrderId}
        userRole={userRole}
      />
      
      {userRole === "BY_SUPPORT_ADMIN" ? 
                <SupportAdminMenu setVisible={setVisible} visible={visible} /> :
      <AdminMenu setVisible={setVisible} visible={visible} />
      }
    </div>
  );
};

export default AdminOrdersGarmentInfo;
